import { useEffect, useState } from "react";
import { kpsiGet, kpsiPost } from "./kpsiApi";

type Row = {
  id: number;
  name: string;
  hrName?: string;
  hrPhone?: string;
};

interface Props {
  onEdit: (id: number) => void;
  onAdd: () => void;
  onFlash: (msg: string) => void;
}

export default function KpsiCompaniesList({ onEdit, onAdd, onFlash }: Props) {
  const [rows, setRows] = useState<Row[]>([]);

  async function load() {
    const data = await kpsiGet<{ rows: Row[] }>("/Kpsi/Companies");
    setRows(data.rows ?? []);
  }

  useEffect(() => {
    void load().catch((e) => onFlash(e instanceof Error ? e.message : "Load failed"));
  }, [onFlash]);

  async function onDelete(id: number) {
    if (!window.confirm("Delete this company?")) return;
    await kpsiPost(`/Kpsi/Companies/${id}/Delete`);
    onFlash("Company deleted.");
    await load();
  }

  return (
    <>
      <h1>View Companies</h1>
      <p>
        <button type="button" className="kpsi-btn-primary" onClick={onAdd}>
          Add New Company
        </button>
      </p>
      <table className="kpsi-records">
        <thead>
          <tr>
            <th>Name</th>
            <th>HR Contact</th>
            <th>HR Phone</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.name}</td>
              <td>{r.hrName}</td>
              <td>{r.hrPhone}</td>
              <td className="actions">
                <button type="button" onClick={() => onEdit(r.id)}>Edit</button>
                {" | "}
                <button type="button" onClick={() => void onDelete(r.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
